import {
  SET_SELECTED_PAYER,
  SET_TARGET_PAYER_TYPE,
  CLEAR_SELECTED_PAYER,
} from 'util/actions';

const initialState = {
  selectedPayer: null,
  targetPayerType: null,
};

const name = 'convertPayer';
export const selector = (state) => state[name];

const convertPayer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_PAYER:
      return {
        ...state,
        selectedPayer: action.payload,
      };
    case SET_TARGET_PAYER_TYPE:
      return {
        ...state,
        targetPayerType: action.payload,
      };
    case CLEAR_SELECTED_PAYER:
      return {
        ...state,
        selectedPayer: null,
        targetPayerType: null,
      };
    default:
      return state;
  }
};

export default convertPayer;
